export default __webpack_public_path__ + "static/hero_3-d7267e68cf9c06bca5ec1102245d7cde.jpg";